export function onClickGoogleAnalyticsEvent(category, action, label) {
    if (window.dataLayer === null) {
        window.dataLayer = [];
    }

    var newEvent = {
        event: 'event',
        category: category,
        action: action,
        label: label,
    };

    window.dataLayer.push(newEvent);
}
